// angular import
import { Injectable, signal, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

// project import
import { environment } from 'src/environments/environment';
import { User } from '../types/user';

// Import the 'map' operator from 'rxjs/operators'
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private router = inject(Router);
  private http = inject(HttpClient);

  private currentUserSignal = signal<User | null>(null);
  isLogin: boolean = false;
  private message: string = '';
  private institucionService: string;

  constructor() {
    // Initialize the signal with the current user from localStorage
    const storedUser = localStorage.getItem('currentUser');
    if (storedUser) {
      this.currentUserSignal.set(JSON.parse(storedUser) as User);
      this.isLogin = true;
    }
  }

  public get currentUserValue(): any | null {
    // Access the current user value from the signal
    return this.currentUserSignal();
  }

  nombre: string;
  apellido: string;
  telefono: string;
  username: string;
  identificacion: string;

  public get currentUserName(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.username : null;
  }

  public get currentUserNombreU(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.nombre : null;
  }

  public get currentUserApellido(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.apellido : null;
  }

  public get currentUserTelefono(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.telefono : null;
  }

  public get currentUserIdentificacion(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.identificacion : null;
  }

  public get currentUserEmail(): string | null {
    const currentUser = this.currentUserValue;
    return currentUser ? currentUser.email : null;
  }

  public get currentUserIdInstitucio(): string | null {
    const currentUser = this.currentUserValue;
    console.log(currentUser);

    return currentUser ? currentUser._id : null;
  }

  login(username: string, password: string, ip: string) {
    const tipo = 'AD';
    return this.http.post<User>(`${environment.apiUrl3}/ingreso/ingreso`, { usuario: username, clave: password, tipo, ip }).pipe(
      map(async (user: any) => {
        localStorage.setItem('currentUser', JSON.stringify(user.data));
        const empresaIdentificacion = user.data.datos_empresa?.identificacion || '';
        localStorage.setItem('empresaIdentificacion', empresaIdentificacion);
        const role = user.data.idRol?.nombre;
        localStorage.setItem('roleUser', role);
        const productos = user.data.idProducto;
        localStorage.setItem('productos', JSON.stringify(productos));
        const menu = user.data.idMenu;
        localStorage.setItem('menu', JSON.stringify(menu));
        localStorage.setItem('cuentas', JSON.stringify(user.data.datos_empresa.idCuentas));

        this.currentUserSignal.set(user.data);
        this.isLogin = true;
        return user;
      })
    );
  }

  login1(email: string, password: string) {
    return this.http.post<User>(`${environment.apiUrl}/api/account/login`, { email, password }).pipe(
      map((user: User) => {
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.isLogin = true;
        // Update the signal with the new user
        this.currentUserSignal.set(user);

        return user;
      })
    );
  }

  private static log(message: string): any {
    console.log(message);
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  servicioPost(envURL: any, complemento: any, body: any, log?: any): Observable<any> {
    return this.http.post(envURL + complemento, body, this.httpOptions).pipe(
      tap((_) => AuthenticationService.log(log)),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  isLoggedIn() {
    return this.isLogin;
  }

  logout() {
    // Remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('secret');
    this.isLogin = false;
    // Update the signal to null
    this.currentUserSignal.set(null);
    this.router.navigate(['/login']);
  }

  private static handleErrorLogin(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    return throwError('Something bad happened; please try again later.');
  }

  validarOTPLogin(loginData: any): Promise<any> {
    return this.http
      .post<any>(environment.apiUrl3 + `/otp/verificarOtpKey`, loginData, this.httpOptions)
      .pipe(
        tap((res) => {
          const data = res;
        }),
        catchError(AuthenticationService.handleErrorLogin)
      )
      .toPromise();
  }

  // Método para establecer el mensaje
  setMessage(message: string) {
    this.message = message;
  }

  // Método para obtener el mensaje
  getMessage() {
    return this.message;
  }
}
